import axios from 'axios';

const HTTP = axios.create({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  }
});

const HTTPDashboard = axios.create({
  headers: {
    'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
    'Accept': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  }
});

const validateValidStatus = (response) => {
  if (response.status === 204) {
    throw new Error('Nenhuma condição de pagamento encontrada para este produto.');
  }
  return response;
};

const handleDefaultErrors = (error) => {
  if (error.response === undefined) {
    throw new Error('Falha na comunicação com o servidor');
  }

  if (error.response.status === 419) {
    throw new Error('A sessão do seu usuário expirou, por favor realize o login novamente');
  }

  if (error.response.status === 401) {
    throw new Error('Não autenticado');
  }

  if (error.response.status === 500) {
    throw new Error('Erro na comunicação com o servidor');
  }

  throw new Error(_.get(error, 'response.data.message', 'Ops! Tivemos um problema com o servidor.'));
};

const defineDefaultInterceptors = (HTTP) => {
  HTTP.interceptors.response.use((success) => validateValidStatus(success), handleDefaultErrors);
};

const defineDefaultInterceptorsForDashboard = (HTTPDashboard) => {
  HTTPDashboard.interceptors.response.use((response) => response, handleDefaultErrors);
};

defineDefaultInterceptors(HTTP);
defineDefaultInterceptorsForDashboard(HTTPDashboard);

export {
  HTTP,
  HTTPDashboard
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/services/http_service.js